module.exports = __webpack_public_path__ + "img/welcome4.5bb99e52.png";